'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_67e042e7 = {"cell":"Head_module_cell__87074b51","icons":"Head_module_icons__87074b51","pointer":"Head_module_pointer__87074b51"};
require("../../../assets/cjs/components/Table/src/Head~CbTWLE5c.css");

exports.default = modules_67e042e7;
//# sourceMappingURL=Head.module.less.js.map
